// eslint-disable-next-line quotes
const ACTIVE_TAB_CLASS = 'tabs__active';
const ACTIVE_TRIGGER_CLASS = 'btn--active';
const TAB = '.tabs__item';
// eslint-disable-next-line quotes
const TAB_TRIGGER = "[data-toggle='tab']";
const TAB_TARGET = '[data-target]';

export default (namespace) => ({
  namespace: null,
  init() {
    this.namespace = namespace;
    this.addListenersToTriggers();
  },

  addListenersToTriggers() {
    this.$el.querySelectorAll(TAB_TRIGGER).forEach((el) =>
      el.addEventListener('click', (e) => {
        this.$el.querySelectorAll(TAB_TRIGGER).forEach((el) => {
          el.classList.remove(ACTIVE_TRIGGER_CLASS);
        });
        let trigger = e.target.closest(TAB_TARGET);
        this.makeTriggerActive(trigger);
        this.toggleTab(trigger.dataset.target);
      })
    );
  },

  makeTriggerActive(trigger) {
    trigger.classList.add(ACTIVE_TRIGGER_CLASS);
  },

  toggleTab(target) {
    const targetedTab = document.getElementById(`${this.namespace}-${target}`);
    this.$el
      .querySelectorAll(TAB)
      .forEach((el) => el.classList.remove(ACTIVE_TAB_CLASS));
    targetedTab.classList.add(ACTIVE_TAB_CLASS);
  },
});
